var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-sheet',{attrs:{"id":"core-view","elevation":"2"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{attrs:{"id":"router-view"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }